import { createFileRoute } from '@tanstack/react-router';
import { ReceiptMerchantCleanupPage } from './ReceiptMerchantCleanupPage';
import { z } from 'zod';

const searchSchema = z.object({
  merchantName: z.string().optional(),
  assignmentState: z.enum(['assigned', 'unassigned', 'either']).optional().default('either'),
  transactionDateAfter: z.string().optional(),
  transactionDateBefore: z.string().optional(),
  createdAfter: z.coerce.date().optional(),
  createdBefore: z.coerce.date().optional(),
  updatedAfter: z.coerce.date().optional(),
  updatedBefore: z.coerce.date().optional(),
  sortBy: z
    .enum(['merchant_name', 'transaction_date', 'created_at', 'updated_at'])
    .optional()
    .default('updated_at'),
  sortOrder: z.enum(['asc', 'desc']).optional().default('desc'),
  page: z.coerce.number().positive().int().optional().default(1),
  pageSize: z.coerce.number().positive().int().optional().default(25),
});

export const Route = createFileRoute('/_protected/admin/internal-tools/receipt-merchant-cleanup/')({
  component: ReceiptMerchantCleanupPage,
  validateSearch: searchSchema,
});
